import { Button } from "@mui/material";
import useColors from "../../api/hooks/useColors";

export default function SecondaryButton(props) {
  const colors = useColors();

  const new_sx = {
    ...props.sx,
    borderRadius: "10px",
    padding: "8px",
    borderColor: colors.primary_48percent,
    color: colors.primary_main,
    textTransform: "none",
    background: colors.common_white,
    "&:hover": {
      background: colors.primary_8percent,
      border: "none",
    },
  };

  const new_props = { ...props, variant: "outlined", sx: new_sx };

  return (
    <Button disableRipple {...new_props}>
      {props.children}
    </Button>
  );
}
